import moment from 'moment-timezone'

export const getDateAndTimeText = (date) => {
	const dateNow = moment().format('YYYY-MM-DD')
	const dateSend = moment(date).format('YYYY-MM-DD')
    let dateTemp = ''

	if (dateNow === dateSend) {
        dateTemp = 'сьогодні, ' + moment(date).format('HH:mm')
    } else if (moment(dateNow).diff(moment(dateSend), 'days') === 1) {
        dateTemp = 'вчора, ' + moment(date).format('HH:mm')
    } else {
        dateTemp = moment(date).format('DD.MM.YYYY, HH:mm')
    }

    return dateTemp
}

export const getDateOnly = (date) => {
    let dateTemp = null
    if(date) {
        dateTemp = moment.tz(moment(date), 'Europe/Kiev').format('YYYY-MM-DD')
    }
    return dateTemp
}

export const getDateOnlyToday = () => {
    let dateToday = moment.tz(moment(), 'Europe/Kiev').format('YYYY-MM-DD')

    return dateToday
}

export const getDateOnlyUa = (date) => {
    let dateToday = moment.tz(moment(date), 'Europe/Kiev').format('DD.MM.YYYY')

    return dateToday
}